// eslint-disable-next-line
import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useNavigate } from "react-router-dom";

// Redux
import { useSelector } from "react-redux";

// Service
import ItemService from "../../../services/supplier_appCommonService";

// Components
import Layout from "../../../Layout/Layout";
import { InputField } from "../../../Components/formElements/InputField";
import { ComboboxField } from "../../../Components/formElements/ComboboxField";
import { MultiselectField } from "../../../Components/formElements/MultiselectField";
import { TextAreaField } from "../../../Components/formElements/TextAreaField";
import { TableStatusField } from "../../../Components/formElements/TableStatusField";
import DataTable from "react-data-table-component";
import SuccessRegisterModal from "../../../Components/SuccessRegisterModal";
import Constants from "../../../common/SupplierConstants";
import FailureModal from "../../../Components/Modal/supplier_app/FailureModal";
import CommonItemLevelDatatableModal from "../../../Components/Modal/supplier_app/CommonItemLevelDatatableModal";
import FileViewerModal from "../../../Components/FileViewer/FileViewerModal";
import BuyerAuctionFormModal from "./BuyerAuctionFormModal";
import AuctionCancelModal from "./AuctionCancelModal";
import CreateRFQBidders from "./CreateRFQBidders";

const BuyerReverseAuctionDetails = () => {
  const navigate = useNavigate();

  let auctionId = useSelector(
    (state) => state.eauctionSlice.eauction.auctionNr,
  );

  // ── Tab state ─────────────────────────────────────────────────────────────
  const [activeTab, setActiveTab] = useState(1);
  const totalTabs = 6;
  const tabLabels = [
    { id: 1, label: "Auction Creation", icon: "bi-info-circle" },
    { id: 2, label: "Configuration", icon: "bi-gear" },
    { id: 3, label: "Add Item", icon: "bi-box" },
    { id: 4, label: "Suppliers", icon: "bi-people" },
    { id: 5, label: "Price", icon: "bi-currency-dollar" },
    { id: 6, label: "Schedule", icon: "bi-calendar3" },
  ];

  // ── Accordion visibility ──────────────────────────────────────────────────
  const [isCardVisible2, setCardVisible2] = useState(true);
  const [isCardVisible5, setCardVisible5] = useState(true);
  const [isCardVisible6, setCardVisible6] = useState(true);
  const [isCardVisible7, setCardVisible7] = useState(true);

  // ── Edit mode ─────────────────────────────────────────────────────────────
  const [editMode, setEditMode] = useState(true); // true = view-only, false = editing

  // ── Master data ───────────────────────────────────────────────────────────
  const [getcurrency, setcurrency] = useState([]);
  const [getDropdownData, setDropdownData] = useState("");

  // ── File viewer ───────────────────────────────────────────────────────────
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);
  const handleViewFile = (id) => {
    setFileViewData(id);
    setShowFileViewModal(true);
  };
  const handleViewFileHide = () => setShowFileViewModal(false);

  // ── Modals ────────────────────────────────────────────────────────────────
  const [getShowSuccessModal, setShowSuccessModal] = useState(false);
  // eslint-disable-next-line
  const [getModalInfo, setModalInfo] = useState({
    title: "Auction",
    successMsg: "",
  });
  const hideSuccessModal = () => setShowSuccessModal(false);

  const [getShowFailureModal, setShowFailureModal] = useState(false);
  // eslint-disable-next-line
  const [getErrorFields, setErrorFields] = useState([]);
  const [getFailureModal] = useState({ title: "Warning", ErrorMsg: "" });
  const hideFailureModal = () => setShowFailureModal(false);

  const [getCreateDynamicformModelShow, setCreateDynamicformModelShow] =
    useState(false);
  // eslint-disable-next-line
  const [getFormModalData, setFormModalData] = useState({});
  const hideModalStatus = () => setCreateDynamicformModelShow(false);

  const [getCancelModalStatus, setCancelModalStatus] = useState(false);
  const cancelModalShow = () => setCancelModalStatus(true);
  const cancelModalHide = () => setCancelModalStatus(false);

  // ── Item level modal ──────────────────────────────────────────────────────
  // eslint-disable-next-line
  const [getItemLevelData, setItemLevelData] = useState([]);
  // eslint-disable-next-line
  const [getItemLevelColumns, setItemLevelColumns] = useState([]);
  // eslint-disable-next-line
  const [getModalTitle, setModalTitle] = useState("");
  const [itemLevelModalShow, setItemLevelModalShow] = useState(false);
  const itemLevelHideModal = () => setItemLevelModalShow(false);

  // ── Supplier modal ────────────────────────────────────────────────────────
  const [getSupplierModal, setSupplierModal] = useState(false);
  const [selectedSuppliers, setSelectedSuppliers] = useState([]);
  const [getSupplierData, setSupplierData] = useState([]);
  const suppplierModalShow = () => setSupplierModal(true);
  const supplerMoadHide = () => setSupplierModal(false);
  const handleSelectedRows = (rows) => setSelectedSuppliers(rows);
  const handlePassDataToParent = (data) => {
    setSupplierData((prev) => [
      ...prev,
      ...data.filter(
        (n) => !prev.some((e) => e.AssociateNumber === n.AssociateNumber),
      ),
    ]);
  };
  const removeSupplierRow = (AssociateNumber) =>
    setSupplierData((prev) =>
      prev.filter((r) => r.AssociateNumber !== AssociateNumber),
    );

  // ── Form inputs (mirrors creation page state) ─────────────────────────────
  const [formInputs, setFormInputs] = useState({
    auctionType: "",
    auctionTitle: "",
    buyerCategory: "",
    auctionCurrencies: "",
    othercurrencies: "",
    auctionDescription: "",
    // Configuration
    startPrice: false,
    firstQuote: false,
    firstQuoteBy: "Supplier",
    displayRank: "showToAll",
    mbdType: "anyAmount",
    vendorMasking: false,
    bidConfigType: "parallel",
    bidType: "perUnit",
    timeInterval: "",
    // Price
    itemPrices: {},
    itemQuantities: {},
    itemMbd: {},
    itemReservePrice: {},
    mbdValue: "",
    fractions: "2",
    reservePrice: "",
    bidTimings: {},
    supplierInitialPrices: {},
    effectiveClosingDate: "",
    effectiveClosingTime: "",
    // Schedule
    newBidReceived: "",
    auctionAutoExtended: "",
    extensionCycles: "",
    // Status
    auctionStatus: "Publish",
    items: [],
    supplierList: [],
  });

  const [getOpenCloseInput, setOpenCloseInput] = useState({
    openingDate: "",
    openingTime: "",
    closingDate: "",
    closingTime: "",
  });

  // ── Line Items ────────────────────────────────────────────────────────────
  const lineItemsDefault = [
    {
      local_id: 1,
      itemCategory: "",
      itemNo: "",
      itemCode: "",
      itemDescription: "",
      uom: "",
    },
  ];
  const [getLineItemstData, setLineItemsData] = useState(lineItemsDefault);

  const handleLineItemsInputChange = (local_id, event) => {
    const { name, value } = event.target;
    setLineItemsData((prev) =>
      prev.map((r) => (r.local_id === local_id ? { ...r, [name]: value } : r)),
    );
  };
  const addPOItemRowLineItem = () => {
    setLineItemsData((prev) => {
      const newId =
        prev.length > 0 ? Math.max(...prev.map((r) => r.local_id)) + 1 : 1;
      return [...prev, { ...lineItemsDefault[0], local_id: newId }];
    });
  };
  const removePOItemRowLineItem = (local_id) =>
    setLineItemsData((prev) => prev.filter((r) => r.local_id !== local_id));

  // ── Bid timings calculator (mirrors creation page) ────────────────────────
  const calculateBidTimings = (lineItems = getLineItemstData) => {
    if (!getOpenCloseInput.openingDate || !getOpenCloseInput.openingTime)
      return {};

    const openingDateTime = new Date(
      `${getOpenCloseInput.openingDate}T${getOpenCloseInput.openingTime}`,
    );
    const closingDateTime = new Date(
      `${getOpenCloseInput.closingDate}T${getOpenCloseInput.closingTime}`,
    );
    const auctionDurationMs = closingDateTime - openingDateTime;
    const timings = {};

    if (formInputs.bidConfigType === "serial") {
      const lotOrder = [];
      const lotGroups = {};

      lineItems.forEach((item) => {
        const key = item.local_id;
        const rawLot = formInputs.bidTimings?.[key]?.lotNumber;
        const lotKey =
          rawLot !== undefined && rawLot !== "" && rawLot !== null
            ? String(rawLot)
            : `__unset_${key}`;
        if (!lotGroups[lotKey]) {
          lotGroups[lotKey] = [];
          lotOrder.push(lotKey);
        }
        lotGroups[lotKey].push(item);
      });

      lotOrder.sort((a, b) => {
        const aU = a.startsWith("__unset_"),
          bU = b.startsWith("__unset_");
        if (aU && bU) return 0;
        if (aU) return 1;
        if (bU) return -1;
        return Number(a) - Number(b);
      });

      lotOrder.forEach((lotKey, slotIndex) => {
        const slotStart = new Date(
          openingDateTime.getTime() + slotIndex * auctionDurationMs,
        );
        const slotEnd = new Date(slotStart.getTime() + auctionDurationMs);
        const isUnset = lotKey.startsWith("__unset_");
        lotGroups[lotKey].forEach((item) => {
          const existingLot = formInputs.bidTimings?.[item.local_id]?.lotNumber;
          timings[item.local_id] = {
            serialNumber: slotIndex + 1,
            lotNumber: isUnset ? (existingLot ?? "") : lotKey,
            startTime: slotStart,
            endTime: slotEnd,
          };
        });
      });
    } else if (formInputs.bidConfigType === "staggered") {
      const intervalMs = (parseFloat(formInputs.timeInterval) || 5) * 60 * 1000;
      lineItems.forEach((item, index) => {
        const itemEnd = new Date(
          closingDateTime.getTime() + index * intervalMs,
        );
        timings[item.local_id] = {
          serialNumber: index + 1,
          startTime: openingDateTime,
          endTime: itemEnd,
        };
      });
    }

    return timings;
  };

  // ── Re-calculate bid timings whenever relevant deps change ────────────────
  useEffect(() => {
    const newTimings = calculateBidTimings(getLineItemstData);
    let effectiveClosingDate = getOpenCloseInput.closingDate;
    let effectiveClosingTime = getOpenCloseInput.closingTime;

    if (
      formInputs.bidConfigType === "serial" &&
      getOpenCloseInput.openingDate &&
      getOpenCloseInput.openingTime &&
      getOpenCloseInput.closingDate &&
      getOpenCloseInput.closingTime
    ) {
      const opening = new Date(
        `${getOpenCloseInput.openingDate}T${getOpenCloseInput.openingTime}`,
      );
      const closing = new Date(
        `${getOpenCloseInput.closingDate}T${getOpenCloseInput.closingTime}`,
      );
      const durationMs = closing - opening;
      const lotKeys = new Set();
      getLineItemstData.forEach((item) => {
        const rawLot = newTimings?.[item.local_id]?.lotNumber;
        lotKeys.add(
          rawLot !== undefined && rawLot !== "" && rawLot !== null
            ? String(rawLot)
            : `__unset_${item.local_id}`,
        );
      });
      const totalLots = lotKeys.size;
      if (totalLots > 1 && durationMs > 0) {
        const extended = new Date(opening.getTime() + totalLots * durationMs);
        const pad = (n) => String(n).padStart(2, "0");
        effectiveClosingDate = `${extended.getFullYear()}-${pad(extended.getMonth() + 1)}-${pad(extended.getDate())}`;
        effectiveClosingTime = `${pad(extended.getHours())}:${pad(extended.getMinutes())}`;
      }
    }

    setFormInputs((prev) => ({
      ...prev,
      bidTimings: newTimings,
      effectiveClosingDate,
      effectiveClosingTime,
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    formInputs.bidConfigType,
    formInputs.timeInterval,
    getOpenCloseInput.openingDate,
    getOpenCloseInput.openingTime,
    getOpenCloseInput.closingDate,
    getOpenCloseInput.closingTime,
    getLineItemstData,
  ]);

  // ── Dropdown effect ───────────────────────────────────────────────────────
  useEffect(() => {
    if (!getDropdownData?.textField) return;
    if (getDropdownData.textField === "auctionCurrencies") {
      setFormInputs((prev) => ({
        ...prev,
        auctionCurrencies: getDropdownData.name,
        auctionCurrenciesCode: getDropdownData.code,
        auctionCurrencie: getDropdownData.selected,
      }));
    } else if (getDropdownData.textField === "othercurrencies") {
      setFormInputs((prev) => ({
        ...prev,
        othercurrencies: getDropdownData.name,
        othercurrenciesCode: getDropdownData.code,
        othercurrencie: getDropdownData.selected,
      }));
    } else if (getDropdownData.textField === "auctionType") {
      setFormInputs((prev) => ({ ...prev, auctionType: getDropdownData.id }));
    } else if (getDropdownData.textField === "fractions") {
      setFormInputs((prev) => ({ ...prev, fractions: getDropdownData.id }));
    } else if (getDropdownData.textField === "newBidReceived") {
      setFormInputs((prev) => ({
        ...prev,
        newBidReceived: getDropdownData.id,
      }));
    } else if (getDropdownData.textField === "auctionAutoExtended") {
      setFormInputs((prev) => ({
        ...prev,
        auctionAutoExtended: getDropdownData.id,
      }));
    } else if (getDropdownData.textField === "bidType") {
      setFormInputs((prev) => ({ ...prev, bidType: getDropdownData.id }));
    } else {
      setFormInputs((prev) => ({
        ...prev,
        [getDropdownData.textField]: getDropdownData.name,
        [getDropdownData.textCode]: getDropdownData.code,
        [getDropdownData.textDesc]: getDropdownData.description,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getDropdownData]);
  const formatDateForInput = (dateStr) => {
    if (!dateStr) return "";
    const d = new Date(dateStr);
    if (isNaN(d)) return "";
    return d.toISOString().split("T")[0];
  };
  const loadInitialPageData = async () => {
    if (!auctionId) {
      window.history.back();
      return;
    }
    const toastId = toast.loading("Loading...", { position: "top-right" });
    try {
      const item = await ItemService.generateQueryV1({
        queryName: "ReverseAuctionDetail",
        documentNumber: auctionId,
      });
      if (item?.status === 200) {
        const res = item.data[0];
        setFormInputs((prev) => ({ ...prev, ...res }));
        setOpenCloseInput({
          openingDate: formatDateForInput(res.openingDate),
          openingTime: res.openingTime || "",
          closingDate: formatDateForInput(res.closingDate),
          closingTime: res.closingTime || "",
        });
        if (res.items) setLineItemsData(res.items);
        if (res.supplierList) setSupplierData(res.supplierList);
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
    } catch (err) {
      console.error("API call error:", err);
      toast.error("Something went wrong", {
        duration: 4000,
        position: "top-right",
      });
    } finally {
      toast.dismiss(toastId);
    }
  };

  const getMasterDataFunc = async () => {
    await ItemService.getMasterData({ codeType: "currency" }).then((item) => {
      if (item?.status === 200) setcurrency(item?.data);
      else setcurrency([]);
    });
  };

  useEffect(() => {
    getMasterDataFunc();
    loadInitialPageData();
    localStorage.setItem("menu", "eAuction");
    localStorage.setItem("submenu", "Reverse Auction");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auctionId]);

  // ── Update handler ────────────────────────────────────────────────────────
  const handleUpdate = async () => {
    const obj = {
      auctionNr: auctionId,
      ...formInputs,
      items: getLineItemstData,
      supplierList: getSupplierData,
      openingDate: getOpenCloseInput.openingDate,
      openingTime: getOpenCloseInput.openingTime,
      closingDate:
        formInputs.effectiveClosingDate || getOpenCloseInput.closingDate,
      closingTime:
        formInputs.effectiveClosingTime || getOpenCloseInput.closingTime,
      openingDateTime: `${getOpenCloseInput.openingDate} ${getOpenCloseInput.openingTime}`,
      closingDateTime: `${formInputs.effectiveClosingDate || getOpenCloseInput.closingDate} ${formInputs.effectiveClosingTime || getOpenCloseInput.closingTime}`,
    };
    try {
      const res = await ItemService.updateAuctionDetail(obj);
      if (res?.status === 200) {
        toast.success("Updated Successfully", { position: "top-right" });
        setEditMode(true);

        // Auto-send modification emails to all suppliers
        ItemService.auctionSendModification({
          auctionId: auctionId,
          changeNote:
            "The auction details have been updated. Please review the revised schedule.",
        }).catch((e) => console.warn("Modification email failed:", e));

        navigate(Constants.EAUCTION_BUYERAUCTION_LIST);
      } else {
        toast.error(res?.message || "Update failed", { position: "top-right" });
      }
    } catch (err) {
      console.error("Update error:", err);
      toast.error("Something went wrong", { position: "top-right" });
    }
  };

  //  Navigation
  const navigateToWorkflow = () => window.history.back();
  const navigateToLiveAuction = () =>
    navigate(Constants.EAUCTION_LIVE_AUCTION_DETAILS);

  //  Static options
  const buyerCategories = [
    {
      id: 1,
      desc: "ProcurementDepartmentdesc",
      name: "Procurement Department",
      code: "ProcurementDepartmentcode",
    },
    {
      id: 2,
      desc: "PurchaseManagerdesc",
      name: "Purchase Manager",
      code: "PurchaseManagercode",
    },
    {
      id: 3,
      desc: "ProjectManagerdesc",
      name: "Project Manager",
      code: "ProjectManagercode",
    },
    {
      id: 4,
      desc: "FinanceDepartmentdesc",
      name: "Finance Department",
      code: "FinanceDepartmentcode",
    },
  ];

  const auctionTypeOptions = [
    { id: "Reverse", name: "Reverse Auction", description: "reverseAuction" },
    { id: "Forward", name: "Forward Auction", description: "forwardauction" },
    { id: "Ducth", name: "Ducth Auction", description: "ducthauction" },
    { id: "Package", name: "Package Auction", description: "packageauction" },
  ];

  const fractionOptions = [
    { id: "0", name: "0 Decimal" },
    { id: "1", name: "1 Decimal" },
    { id: "2", name: "2 Decimals" },
    { id: "3", name: "3 Decimals" },
    { id: "4", name: "4 Decimals" },
  ];

  const autoExtensionOptions = [
    { id: "Last 2 minutes", name: "Last 2 minutes" },
    { id: "Last 5 minutes", name: "Last 5 minutes" },
    { id: "Last 10 minutes", name: "Last 10 minutes" },
  ];

  const extensionDurationOptions = [
    { id: "1", name: "1 minute" },
    { id: "2", name: "2 minutes" },
    { id: "5", name: "5 minutes" },
    { id: "10", name: "10 minutes" },
  ];

  const bidTypeOptions = [
    { id: "perUnit", name: "Per Unit", description: "Bid per unit quantity" },
    {
      id: "overall",
      name: "Overall",
      description: "Bid for overall item amount",
    },
  ];

  //  Tab 3: Line Items columns
  const lineItemsColumns = [
    { name: "#", selector: (row, i) => i + 1, width: "60px" },
    {
      // name: "Item Category",
      name: (
        <>
          <i className="bi bi-tags labelIcon me-1"></i>Item Category
        </>
      ),
      selector: (row) => row.itemCategory || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="itemCategory"
          value={row.itemCategory || ""}
          onChange={(e) => handleLineItemsInputChange(row.local_id, e)}
          disabled={editMode}
        />
      ),
      width: "180px",
    },
    {
      // name: "Item Name",
      name: (
        <>
          <i className="bi bi-box-seam labelIcon me-1"></i>Item Name
        </>
      ),
      selector: (row) => row.itemNo || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="itemNo"
          value={row.itemNo || ""}
          onChange={(e) => handleLineItemsInputChange(row.local_id, e)}
          disabled={editMode}
        />
      ),
      width: "180px",
    },
    {
      // name: "Item Code",
      name: (
        <>
          <i className="bi bi-upc-scan labelIcon me-1"></i>Item Code
        </>
      ),
      selector: (row) => row.itemCode || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="itemCode"
          value={row.itemCode || ""}
          onChange={(e) => handleLineItemsInputChange(row.local_id, e)}
          disabled={editMode}
        />
      ),
      width: "180px",
    },
    {
      // name: "Item Description",
      name: (
        <>
          <i className="bi bi-card-text labelIcon me-1"></i>Item Description
        </>
      ),
      selector: (row) => row.itemDescription || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="itemDescription"
          value={row.itemDescription || ""}
          onChange={(e) => handleLineItemsInputChange(row.local_id, e)}
          disabled={editMode}
        />
      ),
      width: "220px",
    },
    {
      // name: "UOM",
      name: (
        <>
          <i className="bi bi-rulers labelIcon me-1"></i>UOM
        </>
      ),
      selector: (row) => row.uom || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="uom"
          value={row.uom || ""}
          onChange={(e) => handleLineItemsInputChange(row.local_id, e)}
          disabled={editMode}
        />
      ),
      width: "120px",
    },
    {
      name: "Delete",
      cell: (row) => (
        <button
          className="btnTable"
          onClick={() => removePOItemRowLineItem(row.local_id)}
          disabled={editMode}
          style={{
            background: editMode ? "#f3f4f6" : "#fee2e2",
            color: editMode ? "#9ca3af" : "#dc2626",
            border: `1px solid ${editMode ? "#e5e7eb" : "#fca5a5"}`,
          }}
        >
          <i className="bi bi-trash3"></i>
        </button>
      ),
      width: "80px",
    },
  ];

  //  Tab 4: Supplier columns
  const suppliersColumns = [
    {
      name: "Delete",
      cell: (row) => (
        <button
          className="btn btn-danger"
          onClick={() => removeSupplierRow(row.AssociateNumber)}
          disabled={editMode}
        >
          <i className="bi bi-trash3"></i>
        </button>
      ),
      width: "100px",
    },
    {
      name: "Supplier ID",
      selector: (row) => row.AssociateNumber || "--",
      cell: (row) => (
        <button className="btnInfo">{row.AssociateNumber || "-"}</button>
      ),
      width: "120px",
    },
    {
      name: "Status",
      selector: (row) => row.status,
      cell: (row) => <TableStatusField status={row.status} />,
      width: "170px",
    },
    {
      name: "Supplier Name",
      selector: (row) => row.organisationName || "--",
      width: "180px",
    },
    {
      name: "SAP Number",
      selector: (row) => row.sapAssociateNumber || "--",
      width: "150px",
    },
    {
      name: "Contact Person",
      selector: (row) => row.contactfirstName || "--",
      width: "150px",
    },
    {
      name: "Contact Number",
      selector: (row) => row.contactNumber || "--",
      width: "150px",
    },
    { name: "Email", selector: (row) => row.email || "--", width: "250px" },
    {
      name: "ICV Score %",
      selector: (row) => row.totalScore || "--",
      width: "150px",
    },
    {
      name: "Created Date",
      selector: (row) => row.createdAt || "--",
      width: "160px",
    },
  ];

  //  Tab 5: Price config columns (mirrors creation page)
  const priceConfigColumns = [
    { name: "#", selector: (row, i) => i + 1, width: "60px" },
    {
      // name: "Item Category",
      name: (
        <>
          <i className="bi bi-tags labelIcon me-1"></i>Item Category
        </>
      ),
      selector: (row) => row.itemCategory || "--",
      width: "180px",
    },
    {
      // name: "Item Name",
      name: (
        <>
          <i className="bi bi-box-seam labelIcon me-1"></i>Item Name
        </>
      ),
      selector: (row) => row.itemNo || "--",
      width: "180px",
    },
    {
      // name: "Item Code",
      name: (
        <>
          <i className="bi bi-upc-scan labelIcon me-1"></i>Item Code
        </>
      ),
      selector: (row) => row.itemCode || "--",
      width: "180px",
    },
    {
      // name: "Description",
      name: (
        <>
          <i className="bi bi-card-text labelIcon me-1"></i>Description
        </>
      ),
      selector: (row) => row.itemDescription || "--",
      width: "220px",
    },
    {
      name: (
        <>
          <i className="bi bi-rulers labelIcon me-1"></i>UOM
        </>
      ),
      selector: (row) => row.uom || "--",
      width: "120px",
    },

    //  Quantity
    {
      // name: "Quantity *",
      name: (
        <>
          <i className="bi bi-123 labelIcon me-1"></i>Quantity *
        </>
      ),
      selector: (row) => formInputs.itemQuantities?.[row.local_id] || "",
      cell: (row) => (
        <input
          type="number"
          min="0"
          disabled={editMode}
          value={formInputs.itemQuantities?.[row.local_id] || ""}
          onChange={(e) =>
            setFormInputs((prev) => ({
              ...prev,
              itemQuantities: {
                ...prev.itemQuantities,
                [row.local_id]: e.target.value,
              },
            }))
          }
          placeholder="0"
          style={numInputStyle}
        />
      ),
      width: "140px",
    },

    //  Per-item MBD (only when mbdType != anyAmount)
    ...(formInputs.mbdType !== "anyAmount"
      ? [
          {
            name: "MBD *",
            cell: (row) => (
              <input
                type="number"
                min="0"
                disabled={editMode}
                value={formInputs.itemMbd?.[row.local_id] || ""}
                onChange={(e) =>
                  setFormInputs((prev) => ({
                    ...prev,
                    itemMbd: {
                      ...prev.itemMbd,
                      [row.local_id]: e.target.value,
                    },
                  }))
                }
                placeholder="0.00"
                style={numInputStyle}
              />
            ),
            width: "130px",
          },
        ]
      : []),

    //  Per-item Reserve Price
    {
      // name: "Reserve Price",
      name: (
        <>
          <i className="bi bi-currency-rupee labelIcon me-1"></i>Reserve Price
        </>
      ),
      cell: (row) => (
        <input
          type="number"
          min="0"
          disabled={editMode}
          value={formInputs.itemReservePrice?.[row.local_id] || ""}
          onChange={(e) =>
            setFormInputs((prev) => ({
              ...prev,
              itemReservePrice: {
                ...prev.itemReservePrice,
                [row.local_id]: e.target.value,
              },
            }))
          }
          placeholder="0.00"
          style={numInputStyle}
        />
      ),
      width: "140px",
    },

    //  Lot No / Seq# for Serial / Staggered
    ...(formInputs.bidConfigType !== "parallel"
      ? [
          {
            name: formInputs.bidConfigType === "serial" ? "Lot No *" : "Seq #",
            selector: (row) =>
              formInputs.bidConfigType === "serial"
                ? (formInputs.bidTimings?.[row.local_id]?.lotNumber ?? "")
                : (formInputs.bidTimings?.[row.local_id]?.serialNumber ?? "--"),
            cell: (row) =>
              formInputs.bidConfigType === "serial" ? (
                <input
                  type="number"
                  min="1"
                  disabled={editMode}
                  value={formInputs.bidTimings?.[row.local_id]?.lotNumber ?? ""}
                  onChange={(e) =>
                    setFormInputs((prev) => ({
                      ...prev,
                      bidTimings: {
                        ...prev.bidTimings,
                        [row.local_id]: {
                          ...(prev.bidTimings?.[row.local_id] || {}),
                          lotNumber: e.target.value,
                        },
                      },
                    }))
                  }
                  placeholder="e.g. 1"
                  style={{
                    width: "70px",
                    padding: "5px 8px",
                    border: `1.5px solid ${editMode ? "#d1d5db" : "#0f766e"}`,
                    borderRadius: "4px",
                    fontSize: "13px",
                    fontWeight: 600,
                    color: "#0f766e",
                    textAlign: "center",
                  }}
                />
              ) : (
                <span style={{ fontWeight: 600, color: "#0f766e" }}>
                  {formInputs.bidTimings?.[row.local_id]?.serialNumber ?? "--"}
                </span>
              ),
            width: "110px",
          },
        ]
      : []),

    //  Start Price
    ...(formInputs.startPrice
      ? [
          {
            name: "Start Price *",
            selector: (row) => formInputs.itemPrices?.[row.local_id] || "",
            cell: (row) => (
              <input
                type="number"
                min="0"
                disabled={editMode}
                value={formInputs.itemPrices?.[row.local_id] || ""}
                onChange={(e) =>
                  setFormInputs((prev) => ({
                    ...prev,
                    itemPrices: {
                      ...prev.itemPrices,
                      [row.local_id]: e.target.value,
                    },
                  }))
                }
                placeholder="0.00"
                style={{ ...numInputStyle, width: "120px" }}
              />
            ),
            width: "170px",
          },
        ]
      : []),

    //  FQ = Buyer mode: per-supplier price columns
    ...(formInputs.firstQuote && formInputs.firstQuoteBy === "Buyer"
      ? (getSupplierData || []).map((sup, idx) => ({
          name: `${sup.organisationName || `Supplier ${idx + 1}`} Price`,
          cell: (row) => (
            <input
              type="number"
              min="0"
              disabled={editMode}
              value={
                formInputs.supplierInitialPrices?.[sup.AssociateNumber]?.[
                  row.local_id
                ] || ""
              }
              onChange={(e) =>
                setFormInputs((prev) => ({
                  ...prev,
                  supplierInitialPrices: {
                    ...prev.supplierInitialPrices,
                    [sup.AssociateNumber]: {
                      ...(prev.supplierInitialPrices?.[sup.AssociateNumber] ||
                        {}),
                      [row.local_id]: e.target.value,
                    },
                  },
                }))
              }
              placeholder="0.00"
              style={numInputStyle}
            />
          ),
          width: "160px",
        }))
      : []),
  ];

  //  Shared styles
  const labelSt = {
    fontSize: "13px",
    fontWeight: 600,
    color: "#374151",
    marginBottom: "6px",
    display: "block",
  };
  const selectSt = {
    width: "100%",
    padding: "8px",
    border: "1px solid #d1d5db",
    borderRadius: "4px",
    fontSize: "13px",
  };
  const numInputStyle = {
    width: "100px",
    padding: "5px 8px",
    border: "1px solid #d1d5db",
    borderRadius: "4px",
    fontSize: "12px",
  };

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            {/*  Page Header  */}
            <h2 className="mainTitle">
              Reverse Auction Details
              <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage">
                {auctionId}
              </span>
            </h2>
            <p className="subText">Reverse Auction Details</p>
            <hr />

            {/*  Action Buttons Bar  */}
            <div
              style={{
                display: "flex",
                gap: "10px",
                flexWrap: "wrap",
                alignItems: "center",
                padding: "12px 16px",
                marginBottom: "20px",
                background: "linear-gradient(135deg,#f0fdf9,#e6f7f5)",
                border: "1px solid #99d4cf",
                borderRadius: "10px",
              }}
            >
              <button
                onClick={navigateToWorkflow}
                style={btnStyle("#fff", "#374151", "1px solid #d1d5db")}
              >
                <i className="bi bi-arrow-return-left"></i> Go Back
              </button>

              {editMode ? (
                <>
                  <button
                    onClick={() => setEditMode(false)}
                    style={btnStyle(
                      "linear-gradient(135deg,#0f766e,#0d9488)",
                      "#fff",
                    )}
                  >
                    <i className="bi bi-pencil-square"></i> Modification
                  </button>
                  <button
                    onClick={navigateToLiveAuction}
                    style={btnStyle(
                      "linear-gradient(135deg,#1d4ed8,#2563eb)",
                      "#fff",
                    )}
                  >
                    <i className="bi bi-broadcast"></i> Live Auction
                  </button>
                  <button
                    onClick={cancelModalShow}
                    style={btnStyle(
                      "linear-gradient(135deg,#dc2626,#b91c1c)",
                      "#fff",
                    )}
                  >
                    <i className="bi bi-x-circle"></i> Cancel Auction
                  </button>
                </>
              ) : (
                <>
                  <button
                    onClick={handleUpdate}
                    style={btnStyle(
                      "linear-gradient(135deg,#059669,#047857)",
                      "#fff",
                    )}
                  >
                    <i className="bi bi-check-circle"></i> Update
                  </button>
                  <button
                    onClick={() => setEditMode(true)}
                    style={btnStyle("#6b7280", "#fff")}
                  >
                    Cancel
                  </button>
                </>
              )}

              <div style={{ marginLeft: "auto" }}>
                <span
                  style={{
                    background: "#134e4a",
                    color: "#a7f3d0",
                    padding: "6px 16px",
                    borderRadius: "20px",
                    fontSize: "12px",
                    fontWeight: 700,
                  }}
                >
                  # {auctionId}
                </span>
              </div>
            </div>

            {/*  Tab Navigation  */}
            <div style={{ marginBottom: "18px", width: "100%" }}>
              <ul
                style={{
                  display: "flex",
                  listStyle: "none",
                  padding: 0,
                  margin: 0,
                  gap: "6px",
                  overflowX: "auto",
                }}
              >
                {tabLabels.map((tab) => (
                  <li key={tab.id} style={{ flex: 1, minWidth: "85px" }}>
                    <button
                      onClick={() => setActiveTab(tab.id)}
                      style={{
                        width: "100%",
                        padding: "5px 6px",
                        border:
                          activeTab === tab.id
                            ? "2px solid #0f766e"
                            : "1px solid #8fb5b1",
                        borderRadius: "8px",
                        // background: "linear-gradient(135deg,#b7d8d5,#9fc7c3)",
                        background: "#88B6F2",
                        color: activeTab === tab.id ? "#0f172a" : "#374151",
                        cursor: "pointer",
                        fontWeight: activeTab === tab.id ? "700" : "600",
                        fontSize: "13px",
                        whiteSpace: "nowrap",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: "2px",
                        boxShadow:
                          activeTab === tab.id
                            ? "0 2px 8px rgba(15,118,110,0.15)"
                            : "0 1px 4px rgba(0,0,0,0.06)",
                        transition: "all 0.3s ease",
                      }}
                    >
                      <i
                        className={`bi ${tab.icon}`}
                        style={{
                          fontSize: "14px",
                          color: activeTab === tab.id ? "#0f766e" : "#475569",
                        }}
                      ></i>
                      <span>
                        {tab.id}. {tab.label}
                      </span>
                    </button>
                  </li>
                ))}
              </ul>
            </div>

            {/*  TAB 1: Auction Creation  */}
            <div style={{ display: activeTab === 1 ? "block" : "none" }}>
              {/* Event Creation */}
              <div className="accordion mb-4">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${isCardVisible2 ? "bi-chevron-right" : "bi-chevron-down"}`}
                          onClick={() => setCardVisible2(!isCardVisible2)}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">EC</span>
                      </Col>
                      <Col xs={10} md={10} lg={10}>
                        <span className="headerTitle">Event Creation</span>
                        <span className="subHeaderTitle">
                          Basic Auction Information
                        </span>
                      </Col>
                    </Row>
                  </h2>
                  <div
                    className={`accordion-collapse collapse show ${isCardVisible2 ? "visible" : ""}`}
                  >
                    <div className="accordion-body">
                      <Row className="pt-2 pb-4">
                        {/* Auction Type */}
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <ComboboxField
                            // label="Auction Type *"
                            label={
                              <>
                                <i className="bi bi-hammer labelIcon"></i>
                                Auction Type
                              </>
                            }
                            placeholder="Select Auction Type"
                            data={auctionTypeOptions}
                            id="auctionType"
                            iconClassName="dropdownIcon"
                            name="auctionType"
                            code="auctionType"
                            setValue={formInputs.auctionType || ""}
                            getvalue={setDropdownData}
                            required
                            disabled={editMode}
                          />
                          {formInputs.auctionType && (
                            <small
                              style={{ color: "#6b7280", fontSize: "11px" }}
                            >
                              {formInputs.auctionType === "Reverse"
                                ? "📉 Bids go lower — lowest bid wins"
                                : "📈 Bids go higher — highest bid wins"}
                            </small>
                          )}
                        </Col>

                        {/* Auction Title */}
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            // label="Auction Title *"
                            label={
                              <>
                                <i className="bi bi-card-heading labelIcon"></i>
                                Auction Title
                              </>
                            }
                            name="auctionTitle"
                            placeholder="Enter auction title"
                            value={formInputs.auctionTitle || ""}
                            onChange={(e) =>
                              setFormInputs((prev) => ({
                                ...prev,
                                auctionTitle: e.target.value,
                              }))
                            }
                            disabled={editMode}
                            required
                          />
                        </Col>

                        {/* Buyer Category */}
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <ComboboxField
                            className="inputBox"
                            // label="Auction Category / Department *"
                            label={
                              <>
                                <i className="bi bi-diagram-3 labelIcon"></i>
                                Auction Category / Department
                              </>
                            }
                            data={buyerCategories}
                            name="buyerCategory"
                            id="buyerCategory"
                            setValue={formInputs.buyerCategory || ""}
                            getvalue={setDropdownData}
                            required
                            disabled={editMode}
                          />
                        </Col>

                        {/* Auction Currency */}
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <MultiselectField
                            // label="Auction Currency"
                            label={
                              <>
                                <i className="bi bi-currency-exchange labelIcon"></i>
                                Auction Currency
                              </>
                            }
                            placeholder="Please select the Auction Currency"
                            data={getcurrency}
                            id="auctionCurrencies"
                            iconClassName="dropdownIcon"
                            name="auctionCurrencies"
                            getvalue={setDropdownData}
                            setValue={formInputs.auctionCurrencie || []}
                            className="dropdownOption"
                            disabled={editMode}
                          />
                        </Col>

                        {/* Other Currency */}
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <MultiselectField
                            // label="Other Currency"
                            label={
                              <>
                                <i className="bi bi-cash-stack labelIcon"></i>
                                Other Currency
                              </>
                            }
                            placeholder="Please select the Other Currencies"
                            data={getcurrency}
                            id="othercurrencies"
                            iconClassName="dropdownIcon"
                            name="othercurrencies"
                            getvalue={setDropdownData}
                            setValue={formInputs.othercurrencie || []}
                            className="dropdownOption"
                            disabled={editMode}
                          />
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>

              {/* Terms & Conditions */}
              <div className="accordion mb-4">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${isCardVisible5 ? "bi-chevron-right" : "bi-chevron-down"}`}
                          onClick={() => setCardVisible5(!isCardVisible5)}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">BI</span>
                      </Col>
                      <Col xs={10} md={10} lg={10}>
                        <span className="headerTitle">Terms & Conditions</span>
                        <span className="subHeaderTitle">
                          Terms & Conditions
                        </span>
                      </Col>
                    </Row>
                  </h2>
                  <div
                    className={`accordion-collapse collapse show ${isCardVisible5 ? "visible" : ""}`}
                  >
                    <div className="accordion-body">
                      <Row className="pt-2 pb-4">
                        <Col
                          xs={12}
                          md={12}
                          lg={12}
                          className="commTopButtonRightLeftPadding"
                        >
                          <TextAreaField
                            className="inputBox"
                            // label="Terms & Conditions"
                            label={
                              <>
                                <i className="bi bi-file-earmark-text labelIcon"></i>
                                Terms & Conditions
                              </>
                            }
                            name="auctionDescription"
                            value={formInputs.auctionDescription || ""}
                            onChange={(e) =>
                              setFormInputs((prev) => ({
                                ...prev,
                                auctionDescription: e.target.value,
                              }))
                            }
                            disabled={editMode}
                            required
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding d-flex align-items-center"
                        >
                          <label style={{ ...labelSt, marginRight: "8px" }}>
                            Event Document
                          </label>
                          {formInputs?.eventDocument ? (
                            <img
                              src="assets/img/newIcons/attached-file.png"
                              className="mt-1 attachmentIcon"
                              alt="attachments"
                              onClick={() =>
                                handleViewFile(formInputs?.eventDocument)
                              }
                              style={{ cursor: "pointer" }}
                            />
                          ) : (
                            <span>--</span>
                          )}
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* ════ TAB 2: Configuration ════ */}
            <div style={{ display: activeTab === 2 ? "block" : "none" }}>
              <div className="accordion mb-4">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col
                        xs={1}
                        md={1}
                        lg={1}
                        className="text-left arrowBtn"
                      ></Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">CF</span>
                      </Col>
                      <Col xs={10} md={10} lg={10}>
                        <span className="headerTitle">
                          Auction Configuration
                        </span>
                        <span className="subHeaderTitle">
                          Bidding rules and display settings
                        </span>
                      </Col>
                    </Row>
                  </h2>
                  <div className="accordion-collapse collapse show visible">
                    <div className="accordion-body">
                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "repeat(3,1fr)",
                          gap: "16px",
                          padding: "8px 0 16px",
                        }}
                      >
                        {/* Bid Configuration Type */}
                        <ConfigCard
                          icon="bi-shuffle"
                          iconColor="#7c3aed"
                          iconBg="#ede9fe"
                          title="Bid Configuration Type *"
                          hint={
                            formInputs.bidConfigType === "parallel"
                              ? "All items can be bid simultaneously"
                              : formInputs.bidConfigType === "serial"
                                ? "Items bid one after another sequentially"
                                : "Items bid with time intervals between them"
                          }
                          disabled={editMode}
                        >
                          <select
                            disabled={editMode}
                            value={formInputs.bidConfigType || "parallel"}
                            onChange={(e) =>
                              setFormInputs((prev) => ({
                                ...prev,
                                bidConfigType: e.target.value,
                              }))
                            }
                            style={{
                              width: "100%",
                              padding: "7px 10px",
                              fontSize: "13px",
                              fontWeight: 500,
                              border: "1.5px solid #e0e7ff",
                              borderRadius: "6px",
                              background: editMode ? "#f9fafb" : "#fff",
                              color: "#1e293b",
                              cursor: editMode ? "not-allowed" : "pointer",
                              outline: "none",
                            }}
                          >
                            <option value="parallel">Parallel</option>
                            <option value="serial">Serial</option>
                            <option value="staggered">Staggered</option>
                          </select>
                        </ConfigCard>

                        {/* Time Interval — only for Staggered */}
                        {formInputs.bidConfigType === "staggered" && (
                          <ConfigCard
                            icon="bi-hourglass-split"
                            iconColor="#f59e0b"
                            iconBg="#fef3c7"
                            title="Time Interval *"
                            hint="Minutes between each item's bid period"
                            disabled={editMode}
                          >
                            <input
                              type="number"
                              min="1"
                              disabled={editMode}
                              value={formInputs.timeInterval || ""}
                              onChange={(e) =>
                                setFormInputs((prev) => ({
                                  ...prev,
                                  timeInterval: e.target.value,
                                }))
                              }
                              placeholder="e.g., 5"
                              style={{
                                width: "100%",
                                padding: "8px",
                                border: "1px solid #fcd34d",
                                borderRadius: "4px",
                                fontSize: "13px",
                              }}
                            />
                          </ConfigCard>
                        )}

                        {/* Start Price */}
                        <ConfigCard
                          icon="bi-tag-fill"
                          iconColor="#0f766e"
                          iconBg="#ccfbf1"
                          title="Start Price"
                          required
                          hint={
                            formInputs.startPrice
                              ? "FQ auto-disabled when Start Price = Yes"
                              : "Suppliers begin bidding from a defined price point"
                          }
                          disabled={editMode}
                        >
                          <RadioGroup
                            name="startPrice"
                            disabled={editMode}
                            value={
                              formInputs.startPrice === true ? "Yes" : "No"
                            }
                            onChange={(v) =>
                              setFormInputs((prev) => ({
                                ...prev,
                                startPrice: v === "Yes",
                                firstQuote:
                                  v === "Yes" ? false : prev.firstQuote,
                              }))
                            }
                          />
                        </ConfigCard>

                        {/* FQ (First Quote) */}
                        <ConfigCard
                          icon="bi-chat-quote-fill"
                          iconColor={
                            formInputs.startPrice ? "#9ca3af" : "#7c3aed"
                          }
                          iconBg={formInputs.startPrice ? "#f3f4f6" : "#ede9fe"}
                          title="FQ (First Quote)"
                          hint={
                            formInputs.startPrice
                              ? "Disabled — Start Price is active"
                              : formInputs.firstQuote
                                ? formInputs.firstQuoteBy === "Supplier"
                                  ? "Suppliers enter their own initial quote"
                                  : "Buyer enters starting prices for each supplier"
                                : "Suppliers submit first quote before live bidding"
                          }
                          faded={formInputs.startPrice}
                          disabled={editMode || formInputs.startPrice}
                        >
                          <RadioGroup
                            name="firstQuote"
                            disabled={editMode || formInputs.startPrice}
                            value={
                              formInputs.firstQuote === true ? "Yes" : "No"
                            }
                            onChange={(v) =>
                              setFormInputs((prev) => ({
                                ...prev,
                                firstQuote: v === "Yes",
                                firstQuoteBy:
                                  v === "Yes" ? prev.firstQuoteBy : "Supplier",
                              }))
                            }
                          />

                          {/* Supplier / Buyer sub-options */}
                          {formInputs.firstQuote && !formInputs.startPrice && (
                            <div
                              style={{
                                marginTop: "10px",
                                display: "flex",
                                gap: "10px",
                                flexWrap: "wrap",
                              }}
                            >
                              {[
                                {
                                  val: "Supplier",
                                  label: "By Supplier",
                                  icon: "bi-person-fill",
                                },
                                {
                                  val: "Buyer",
                                  label: "By Buyer",
                                  icon: "bi-building",
                                },
                              ].map((opt) => {
                                const isActive =
                                  formInputs.firstQuoteBy === opt.val;
                                return (
                                  <label
                                    key={opt.val}
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "6px",
                                      padding: "6px 12px",
                                      borderRadius: "8px",
                                      cursor: editMode
                                        ? "not-allowed"
                                        : "pointer",
                                      fontSize: "12px",
                                      border: isActive
                                        ? "2px solid #6ee7b7"
                                        : "2px solid #e5e7eb",
                                      background: isActive
                                        ? "#ecfdf5"
                                        : "#fafafa",
                                      color: isActive ? "#059669" : "#6b7280",
                                      fontWeight: isActive ? 700 : 500,
                                      opacity: editMode ? 0.75 : 1,
                                    }}
                                  >
                                    <input
                                      type="radio"
                                      name="firstQuoteBy"
                                      style={{ display: "none" }}
                                      disabled={editMode}
                                      checked={isActive}
                                      onChange={() =>
                                        !editMode &&
                                        setFormInputs((prev) => ({
                                          ...prev,
                                          firstQuoteBy: opt.val,
                                        }))
                                      }
                                    />
                                    <i
                                      className={`bi ${opt.icon}`}
                                      style={{ fontSize: "12px" }}
                                    ></i>
                                    {opt.label}
                                  </label>
                                );
                              })}
                              <small
                                style={{
                                  color: "#6b7280",
                                  fontSize: "11px",
                                  width: "100%",
                                  marginTop: "2px",
                                }}
                              >
                                {formInputs.firstQuoteBy === "Supplier"
                                  ? "📌 Suppliers enter their own initial quote after acknowledging T&C"
                                  : "📌 You will enter starting prices for each supplier in the Price tab"}
                              </small>
                            </div>
                          )}
                        </ConfigCard>

                        {/* Display Rank */}
                        <ConfigCard
                          icon="bi-bar-chart-fill"
                          iconColor="#1d4ed8"
                          iconBg="#dbeafe"
                          title="Display Rank"
                          hint={
                            formInputs.displayRank === "showToAll"
                              ? "Each supplier sees their own current rank"
                              : formInputs.displayRank === "onlyLeading"
                                ? "Only L1 bidder sees rank; others see 'Any'"
                                : "Rank not shown to anyone"
                          }
                          disabled={editMode}
                        >
                          <select
                            disabled={editMode}
                            value={formInputs.displayRank || "showToAll"}
                            onChange={(e) =>
                              setFormInputs((prev) => ({
                                ...prev,
                                displayRank: e.target.value,
                              }))
                            }
                            style={{
                              width: "100%",
                              padding: "7px 10px",
                              fontSize: "13px",
                              fontWeight: 500,
                              border: "1.5px solid #e0e7ff",
                              borderRadius: "6px",
                              background: editMode ? "#f9fafb" : "#fff",
                              color: "#1e293b",
                              cursor: editMode ? "not-allowed" : "pointer",
                              outline: "none",
                            }}
                          >
                            <option value="showToAll">Show to All</option>
                            <option value="onlyLeading">
                              Show Only Leading Bidder
                            </option>
                            <option value="notApplicable">
                              Not Applicable
                            </option>
                          </select>
                        </ConfigCard>

                        {/* MBD Type — full width */}
                        <div style={{ gridColumn: "1 / -1" }}>
                          <ConfigCard
                            icon="bi-arrow-down-up"
                            iconColor="#d97706"
                            iconBg="#fef3c7"
                            title="Minimum Bid Difference (MBD) Type"
                            hint={
                              formInputs.mbdType === "atLeastMbd"
                                ? "Each new bid must differ by at least the MBD value"
                                : formInputs.mbdType === "multiplesMbd"
                                  ? "Bids must be multiples of MBD (e.g. 10 → 20 → 30...)"
                                  : "Any bid amount is accepted — no minimum gap enforced"
                            }
                            disabled={editMode}
                          >
                            <div
                              style={{
                                display: "flex",
                                gap: "12px",
                                flexWrap: "wrap",
                              }}
                            >
                              {[
                                {
                                  val: "atLeastMbd",
                                  label: "At Least MBD",
                                  icon: "bi-arrow-down",
                                  activeColor: "#d97706",
                                  activeBg: "#fffbeb",
                                  activeBorder: "#fde68a",
                                },
                                {
                                  val: "multiplesMbd",
                                  label: "Multiples of MBD",
                                  icon: "bi-layers-fill",
                                  activeColor: "#7c3aed",
                                  activeBg: "#f5f3ff",
                                  activeBorder: "#c4b5fd",
                                },
                                {
                                  val: "anyAmount",
                                  label: "Any Amount",
                                  icon: "bi-check-circle-fill",
                                  activeColor: "#059669",
                                  activeBg: "#ecfdf5",
                                  activeBorder: "#6ee7b7",
                                },
                              ].map((opt) => {
                                const isActive = formInputs.mbdType === opt.val;
                                return (
                                  <label
                                    key={opt.val}
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "8px",
                                      padding: "8px 16px",
                                      borderRadius: "8px",
                                      cursor: editMode
                                        ? "not-allowed"
                                        : "pointer",
                                      border: isActive
                                        ? `2px solid ${opt.activeBorder}`
                                        : "2px solid #e5e7eb",
                                      background: isActive
                                        ? opt.activeBg
                                        : "#f9fafb",
                                      color: isActive
                                        ? opt.activeColor
                                        : "#6b7280",
                                      fontWeight: isActive ? 700 : 500,
                                      fontSize: "13px",
                                      transition: "all 0.2s",
                                      opacity: editMode ? 0.75 : 1,
                                    }}
                                  >
                                    <input
                                      type="radio"
                                      name="mbdType"
                                      disabled={editMode}
                                      checked={isActive}
                                      onChange={() =>
                                        !editMode &&
                                        setFormInputs((prev) => ({
                                          ...prev,
                                          mbdType: opt.val,
                                        }))
                                      }
                                      style={{ display: "none" }}
                                    />
                                    <i
                                      className={`bi ${opt.icon}`}
                                      style={{ fontSize: "13px" }}
                                    ></i>
                                    {opt.label}
                                  </label>
                                );
                              })}
                            </div>
                          </ConfigCard>
                        </div>

                        {/* Vendor Masking */}
                        <ConfigCard
                          icon="bi-eye-slash-fill"
                          iconColor="#dc2626"
                          iconBg="#fee2e2"
                          title="Vendor / Supplier Masking"
                          hint={
                            formInputs.vendorMasking
                              ? "Supplier names hidden from buyer until auction closes"
                              : "Supplier names are visible to the buyer"
                          }
                          disabled={editMode}
                        >
                          <RadioGroup
                            name="vendorMasking"
                            disabled={editMode}
                            value={
                              formInputs.vendorMasking === true ? "Yes" : "No"
                            }
                            onChange={(v) =>
                              setFormInputs((prev) => ({
                                ...prev,
                                vendorMasking: v === "Yes",
                              }))
                            }
                          />
                        </ConfigCard>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/*  TAB 3: Add Item  */}
            <div style={{ display: activeTab === 3 ? "block" : "none" }}>
              <div className="accordion mb-4">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${isCardVisible6 ? "bi-chevron-right" : "bi-chevron-down"}`}
                          onClick={() => setCardVisible6(!isCardVisible6)}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">IB</span>
                      </Col>
                      <Col xs={8} md={4} lg={4}>
                        <span className="headerTitle">Items For Bidding</span>
                        <span className="subHeaderTitle">
                          Auction Contact Information Details
                        </span>
                      </Col>
                      <Col xs={12} md={6} lg={6} className="headerButtonAlign">
                        {!editMode && (
                          <Col xs={4} md={2} lg={2}>
                            <button
                              className="btnTable"
                              onClick={addPOItemRowLineItem}
                            >
                              +
                            </button>
                          </Col>
                        )}
                      </Col>
                    </Row>
                  </h2>
                  <div
                    className={`accordion-collapse collapse show ${isCardVisible6 ? "visible" : ""}`}
                  >
                    <div className="accordion-body">
                      <Row>
                        <Col xs={12} md={12} lg={12}>
                          <DataTable
                            columns={lineItemsColumns}
                            data={getLineItemstData}
                            pagination
                            responsive
                            highlightOnHover
                            striped
                          />
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/*  TAB 4: Suppliers  */}
            <div style={{ display: activeTab === 4 ? "block" : "none" }}>
              <div className="accordion mb-4">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${isCardVisible7 ? "bi-chevron-right" : "bi-chevron-down"}`}
                          onClick={() => setCardVisible7(!isCardVisible7)}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">BR</span>
                      </Col>
                      <Col xs={8} md={4} lg={4}>
                        <span className="headerTitle">Bidders</span>
                        <span className="subHeaderTitle">
                          Material / Service Details
                        </span>
                      </Col>
                      <Col xs={12} md={8} lg={8} className="headerButtonAlign">
                        {!editMode && (
                          <>
                            <Col xs={4} md={2} lg={2}>
                              <button
                                className="btnTable"
                                onClick={suppplierModalShow}
                              >
                                Add Bidders
                              </button>
                            </Col>
                            <Col xs={5} md={3} lg={3}>
                              <button
                                className="btnTable"
                                onClick={() => alert("Need to Implement")}
                              >
                                Initiate Bidder Request
                              </button>
                            </Col>
                          </>
                        )}
                      </Col>
                    </Row>
                  </h2>
                  <div
                    className={`accordion-collapse collapse show ${isCardVisible7 ? "visible" : ""}`}
                  >
                    <div className="accordion-body">
                      <Row>
                        <Col xs={12} md={12} lg={12}>
                          <DataTable
                            columns={suppliersColumns}
                            data={getSupplierData}
                            pagination
                            responsive
                            highlightOnHover
                            striped
                          />
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* ════ TAB 5: Price ════ */}
            <div style={{ display: activeTab === 5 ? "block" : "none" }}>
              <div className="accordion mb-4">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col
                        xs={1}
                        md={1}
                        lg={1}
                        className="text-left arrowBtn"
                      ></Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">PR</span>
                      </Col>
                      <Col xs={10} md={10} lg={10}>
                        <span className="headerTitle">Price Configuration</span>
                        <span className="subHeaderTitle">
                          Line items, quantity, MBD, fractions, reserve price
                        </span>
                      </Col>
                    </Row>
                  </h2>
                  <div className="accordion-collapse collapse show visible">
                    <div className="accordion-body">
                      <Row className="pt-2 pb-4">
                        {/* Line Items table */}
                        <Col
                          xs={12}
                          md={12}
                          lg={12}
                          className="commTopButtonRightLeftPadding"
                        >
                          <label style={{ ...labelSt, marginBottom: "8px" }}>
                            Line Items{" "}
                            {formInputs.startPrice && (
                              <span style={{ color: "#1d4ed8" }}>
                                (Enter Start Price per item)
                              </span>
                            )}
                            {formInputs.firstQuote &&
                              formInputs.firstQuoteBy === "Buyer" && (
                                <span style={{ color: "#7c3aed" }}>
                                  {" "}
                                  (Enter Initial Price per Supplier)
                                </span>
                              )}
                          </label>
                          <DataTable
                            columns={priceConfigColumns}
                            data={getLineItemstData}
                            pagination
                            responsive
                            highlightOnHover
                            striped
                            noDataComponent="No items added. Go to Tab 3 to add items."
                          />
                        </Col>

                        {/* Bid Type */}
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding mt-3"
                        >
                          <ComboboxField
                            label="Bid Type *"
                            placeholder="Select Bid Type"
                            data={bidTypeOptions}
                            id="bidType"
                            iconClassName="dropdownIcon"
                            name="bidType"
                            code="bidType"
                            setValue={formInputs.bidType || "perUnit"}
                            getvalue={setDropdownData}
                            required
                            disabled={editMode}
                          />
                          {formInputs.bidType && (
                            <small
                              style={{
                                color: "#6b7280",
                                fontSize: "11px",
                                marginTop: "4px",
                                display: "block",
                              }}
                            >
                              {formInputs.bidType === "perUnit"
                                ? "Suppliers bid per unit quantity"
                                : "Suppliers bid for overall item amount"}
                            </small>
                          )}
                        </Col>

                        {/* MBD Amount (global) */}
                        {formInputs.mbdType !== "anyAmount" && (
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding mt-3"
                          >
                            <label style={labelSt}>
                              MBD Amount *{" "}
                              <span
                                style={{ color: "#6b7280", fontWeight: 400 }}
                              >
                                (
                                {formInputs.mbdType === "atLeastMbd"
                                  ? "At Least"
                                  : "Multiples of"}
                                )
                              </span>
                            </label>
                            <input
                              type="number"
                              min="0"
                              disabled={editMode}
                              value={formInputs.mbdValue || ""}
                              onChange={(e) =>
                                setFormInputs((prev) => ({
                                  ...prev,
                                  mbdValue: e.target.value,
                                }))
                              }
                              placeholder="Enter MBD value"
                              style={selectSt}
                            />
                            {formInputs.mbdType === "multiplesMbd" &&
                              formInputs.mbdValue && (
                                <small
                                  style={{ color: "#6b7280", fontSize: "11px" }}
                                >
                                  Valid: {formInputs.mbdValue},{" "}
                                  {Number(formInputs.mbdValue) * 2},{" "}
                                  {Number(formInputs.mbdValue) * 3}...
                                </small>
                              )}
                          </Col>
                        )}

                        {/* Fractions */}
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding mt-3"
                        >
                          <ComboboxField
                            label="Number of Fractions"
                            placeholder="Select Fractions"
                            data={fractionOptions}
                            id="fractions"
                            iconClassName="dropdownIcon"
                            name="fractions"
                            code="fractions"
                            setValue={formInputs.fractions || "2"}
                            getvalue={setDropdownData}
                            disabled={editMode}
                          />
                        </Col>

                        {/* Reserve Price (global) */}
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding mt-3"
                        >
                          <InputField
                            className="inputBox"
                            label="Reserve Price (Global)"
                            name="reservePrice"
                            id="reservePrice"
                            type="number"
                            min="0"
                            placeholder="Enter reserve price"
                            value={formInputs.reservePrice || ""}
                            onChange={(e) =>
                              setFormInputs((prev) => ({
                                ...prev,
                                reservePrice: e.target.value,
                              }))
                            }
                            disabled={editMode}
                          />
                        </Col>

                        {/* Bid Timing summary for Serial / Staggered */}
                        {formInputs.bidConfigType !== "parallel" &&
                          getLineItemstData.length > 0 && (
                            <Col
                              xs={12}
                              className="commTopButtonRightLeftPadding mt-3"
                            >
                              <div
                                style={{
                                  background: "#e0f2fe",
                                  border: "1px solid #bae6fd",
                                  borderRadius: "6px",
                                  padding: "12px 16px",
                                  fontSize: "12px",
                                  color: "#0369a1",
                                }}
                              >
                                <strong>
                                  ⏱️ Bid Timing Configuration (
                                  {formInputs.bidConfigType === "serial"
                                    ? "Serial (Lot-wise)"
                                    : "Staggered (Interval)"}
                                  )
                                </strong>
                                {formInputs.bidConfigType === "staggered" &&
                                  formInputs.timeInterval && (
                                    <div
                                      style={{
                                        marginTop: "6px",
                                        fontSize: "11px",
                                      }}
                                    >
                                      📌 Each item closes{" "}
                                      <strong>
                                        {formInputs.timeInterval} min
                                      </strong>{" "}
                                      after the previous one
                                    </div>
                                  )}
                                {formInputs.bidConfigType === "serial" && (
                                  <div
                                    style={{
                                      marginTop: "6px",
                                      fontSize: "11px",
                                    }}
                                  >
                                    📌 Enter Lot No in the price table above —
                                    items run one-by-one in lot order
                                  </div>
                                )}
                                {/* Effective closing time banner for serial */}
                                {formInputs.bidConfigType === "serial" &&
                                  formInputs.effectiveClosingDate && (
                                    <div
                                      style={{
                                        marginTop: "8px",
                                        background: "#fff7ed",
                                        border: "1px solid #fed7aa",
                                        borderRadius: "4px",
                                        padding: "6px 10px",
                                        fontSize: "11px",
                                        color: "#9a3412",
                                      }}
                                    >
                                      ⚠️ Effective Auction End:{" "}
                                      <strong>
                                        {formInputs.effectiveClosingDate}{" "}
                                        {formInputs.effectiveClosingTime}
                                      </strong>{" "}
                                      (auto-extended for{" "}
                                      {getLineItemstData.length} lots)
                                    </div>
                                  )}
                                <table
                                  style={{
                                    width: "100%",
                                    marginTop: "10px",
                                    borderCollapse: "collapse",
                                  }}
                                >
                                  <thead>
                                    <tr
                                      style={{
                                        borderBottom: "1px solid #bae6fd",
                                      }}
                                    >
                                      {[
                                        "Lot/Seq",
                                        "Item",
                                        "Start Time",
                                        "End Time",
                                      ].map((h) => (
                                        <th
                                          key={h}
                                          style={{
                                            textAlign: "left",
                                            paddingBottom: "6px",
                                            fontSize: "11px",
                                            fontWeight: 600,
                                          }}
                                        >
                                          {h}
                                        </th>
                                      ))}
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {getLineItemstData.map((item) => {
                                      const timing =
                                        formInputs.bidTimings?.[item.local_id];
                                      return (
                                        <tr
                                          key={item.local_id}
                                          style={{
                                            borderBottom: "1px solid #e0f2fe",
                                          }}
                                        >
                                          <td
                                            style={{
                                              paddingTop: "6px",
                                              paddingBottom: "6px",
                                              fontWeight: 700,
                                              color: "#0f766e",
                                            }}
                                          >
                                            {formInputs.bidConfigType ===
                                            "serial"
                                              ? (timing?.lotNumber ?? "--")
                                              : (timing?.serialNumber ?? "--")}
                                          </td>
                                          <td
                                            style={{
                                              paddingTop: "6px",
                                              paddingBottom: "6px",
                                            }}
                                          >
                                            {item.itemNo ||
                                              item.itemCode ||
                                              `Item ${item.local_id}`}
                                          </td>
                                          <td
                                            style={{
                                              paddingTop: "6px",
                                              paddingBottom: "6px",
                                            }}
                                          >
                                            {timing?.startTime
                                              ? new Date(
                                                  timing.startTime,
                                                ).toLocaleString("en-IN", {
                                                  hour12: true,
                                                  hour: "2-digit",
                                                  minute: "2-digit",
                                                  day: "2-digit",
                                                  month: "short",
                                                })
                                              : "--"}
                                          </td>
                                          <td
                                            style={{
                                              paddingTop: "6px",
                                              paddingBottom: "6px",
                                              color: "#dc2626",
                                              fontWeight: 600,
                                            }}
                                          >
                                            {timing?.endTime
                                              ? new Date(
                                                  timing.endTime,
                                                ).toLocaleString("en-IN", {
                                                  hour12: true,
                                                  hour: "2-digit",
                                                  minute: "2-digit",
                                                  day: "2-digit",
                                                  month: "short",
                                                })
                                              : "--"}
                                          </td>
                                        </tr>
                                      );
                                    })}
                                  </tbody>
                                </table>
                              </div>
                            </Col>
                          )}
                      </Row>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/*  TAB 6: Schedule  */}
            <div style={{ display: activeTab === 6 ? "block" : "none" }}>
              <div className="accordion mb-4">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col
                        xs={1}
                        md={1}
                        lg={1}
                        className="text-left arrowBtn"
                      ></Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">SC</span>
                      </Col>
                      <Col xs={10} md={10} lg={10}>
                        <span className="headerTitle">Auction Schedule</span>
                        <span className="subHeaderTitle">
                          Set start/end time and auto-extension rules
                        </span>
                      </Col>
                    </Row>
                  </h2>
                  <div className="accordion-collapse collapse show visible">
                    <div className="accordion-body">
                      <Row className="pt-2 pb-4">
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Start Date *"
                            name="openingDate"
                            type="date"
                            value={getOpenCloseInput.openingDate || ""}
                            onChange={(e) =>
                              setOpenCloseInput((prev) => ({
                                ...prev,
                                openingDate: e.target.value,
                              }))
                            }
                            required
                            disabled={editMode}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Start Time *"
                            name="openingTime"
                            type="time"
                            value={getOpenCloseInput.openingTime || ""}
                            onChange={(e) =>
                              setOpenCloseInput((prev) => ({
                                ...prev,
                                openingTime: e.target.value,
                              }))
                            }
                            required
                            disabled={editMode}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="End Date *"
                            name="closingDate"
                            type="date"
                            value={getOpenCloseInput.closingDate || ""}
                            onChange={(e) =>
                              setOpenCloseInput((prev) => ({
                                ...prev,
                                closingDate: e.target.value,
                              }))
                            }
                            required
                            disabled={editMode}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="End Time *"
                            name="closingTime"
                            type="time"
                            value={getOpenCloseInput.closingTime || ""}
                            onChange={(e) =>
                              setOpenCloseInput((prev) => ({
                                ...prev,
                                closingTime: e.target.value,
                              }))
                            }
                            required
                            disabled={editMode}
                          />
                        </Col>

                        {/* Date validation */}
                        {getOpenCloseInput.openingDate &&
                          getOpenCloseInput.closingDate &&
                          getOpenCloseInput.closingDate <
                            getOpenCloseInput.openingDate && (
                            <Col
                              xs={12}
                              className="commTopButtonRightLeftPadding"
                            >
                              <div
                                style={{
                                  color: "#dc2626",
                                  fontSize: "12px",
                                  padding: "8px 12px",
                                  background: "#fef2f2",
                                  borderRadius: "4px",
                                  border: "1px solid #fca5a5",
                                }}
                              >
                                ⚠ End Date must be greater than Start Date
                              </div>
                            </Col>
                          )}

                        {/* Effective closing time (Serial mode) */}
                        {formInputs.bidConfigType === "serial" &&
                          formInputs.effectiveClosingDate && (
                            <Col
                              xs={12}
                              className="commTopButtonRightLeftPadding"
                            >
                              <div
                                style={{
                                  background: "#fff7ed",
                                  border: "1px solid #fed7aa",
                                  borderRadius: "6px",
                                  padding: "10px 14px",
                                  fontSize: "12px",
                                  color: "#9a3412",
                                }}
                              >
                                ⚠️{" "}
                                <strong>
                                  Effective Auction End (Serial mode):
                                </strong>{" "}
                                {formInputs.effectiveClosingDate}{" "}
                                {formInputs.effectiveClosingTime}
                                <span
                                  style={{
                                    marginLeft: "8px",
                                    color: "#6b7280",
                                  }}
                                >
                                  (original end extended across{" "}
                                  {getLineItemstData.length} lots)
                                </span>
                              </div>
                            </Col>
                          )}

                        {/* Auto Extension */}
                        <Col
                          xs={12}
                          md={12}
                          lg={12}
                          className="commTopButtonRightLeftPadding mt-3"
                        >
                          <label style={labelSt}>Auto Extension Logic</label>
                          <Row>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <ComboboxField
                                label="Extend if bid received in last"
                                placeholder="Not Applicable"
                                data={autoExtensionOptions}
                                id="newBidReceived"
                                iconClassName="dropdownIcon"
                                name="newBidReceived"
                                code="newBidReceived"
                                setValue={formInputs.newBidReceived || ""}
                                getvalue={setDropdownData}
                                disabled={editMode}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <ComboboxField
                                label="Extension Duration"
                                placeholder="Select"
                                data={extensionDurationOptions}
                                id="auctionAutoExtended"
                                iconClassName="dropdownIcon"
                                name="auctionAutoExtended"
                                code="auctionAutoExtended"
                                setValue={formInputs.auctionAutoExtended || ""}
                                getvalue={setDropdownData}
                                disabled={editMode}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Number of Extension Cycles"
                                name="extensionCycles"
                                id="extensionCycles"
                                type="number"
                                min="1"
                                max="10"
                                placeholder="e.g. 3"
                                value={formInputs.extensionCycles || ""}
                                onChange={(e) =>
                                  setFormInputs((prev) => ({
                                    ...prev,
                                    extensionCycles: e.target.value,
                                  }))
                                }
                                disabled={editMode}
                              />
                            </Col>
                          </Row>
                        </Col>

                        {/* Auction window info */}
                        {getOpenCloseInput.openingDate && (
                          <Col
                            xs={12}
                            className="commTopButtonRightLeftPadding mt-3"
                          >
                            <div
                              style={{
                                background: "#eff6ff",
                                border: "1px solid #bfdbfe",
                                borderRadius: "6px",
                                padding: "12px 16px",
                                fontSize: "12px",
                                color: "#1e40af",
                              }}
                            >
                              <strong>📅 Auction Window:</strong>{" "}
                              {getOpenCloseInput.openingDate}{" "}
                              {getOpenCloseInput.openingTime} →{" "}
                              {formInputs.effectiveClosingDate ||
                                getOpenCloseInput.closingDate}{" "}
                              {formInputs.effectiveClosingTime ||
                                getOpenCloseInput.closingTime}
                            </div>
                          </Col>
                        )}
                      </Row>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/*  Tab Prev / Next  */}
            <Row className="justify-content-end">
              <Col xs={12} md={4} lg={4} className="mb-2">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: "16px",
                    marginBottom: "16px",
                  }}
                >
                  <button
                    className="btnTable"
                    onClick={() =>
                      setActiveTab((prev) => Math.max(1, prev - 1))
                    }
                    disabled={activeTab === 1}
                    style={{ opacity: activeTab === 1 ? 0.4 : 1 }}
                  >
                    ← Previous
                  </button>
                  <span
                    style={{
                      fontSize: "12px",
                      color: "#6b7280",
                      alignSelf: "center",
                    }}
                  >
                    Step {activeTab} of {totalTabs}
                  </span>
                  <button
                    className="btnTable"
                    onClick={() =>
                      setActiveTab((prev) => Math.min(totalTabs, prev + 1))
                    }
                    disabled={activeTab === totalTabs}
                    style={{ opacity: activeTab === totalTabs ? 0.4 : 1 }}
                  >
                    Next →
                  </button>
                </div>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>

      {/*  Modals  */}
      <CreateRFQBidders
        show={getSupplierModal}
        onHide={supplerMoadHide}
        selectedSuppliers={selectedSuppliers}
        onSelectedRows={handleSelectedRows}
        passDataToParent={handlePassDataToParent}
      />
      <SuccessRegisterModal
        show={getShowSuccessModal}
        onHide={hideSuccessModal}
        modaldata={getModalInfo}
        aftersuccess={Constants.EAUCTION_BUYERAUCTION_LIST}
      />
      <BuyerAuctionFormModal
        show={getCreateDynamicformModelShow}
        onHide={hideModalStatus}
        modeldata={getFormModalData}
      />
      <FailureModal
        show={getShowFailureModal}
        onHide={hideFailureModal}
        failuremodaldata={getFailureModal}
        requiredfields={getErrorFields}
      />
      <CommonItemLevelDatatableModal
        show={itemLevelModalShow}
        onHide={itemLevelHideModal}
        columns={getItemLevelColumns}
        data={getItemLevelData}
        title={getModalTitle}
      />
      <FileViewerModal
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData}
      />
      <AuctionCancelModal
        title="Cancel the Auction"
        type="Auction"
        show={getCancelModalStatus}
        onHide={cancelModalHide}
      />
    </main>
  );
};

//  ConfigCard
const ConfigCard = ({
  icon,
  iconColor,
  iconBg,
  title,
  required,
  hint,
  disabled,
  faded,
  children,
}) => (
  <div
    style={{
      background: "#fff",
      border: "1.5px solid #e5e7eb",
      borderRadius: "10px",
      padding: "16px 18px",
      display: "flex",
      flexDirection: "column",
      gap: "12px",
      opacity: faded ? 0.5 : 1,
      boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
      transition: "all 0.2s",
    }}
  >
    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
      <div
        style={{
          width: "32px",
          height: "32px",
          borderRadius: "8px",
          background: iconBg,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
        }}
      >
        <i
          className={`bi ${icon}`}
          style={{ fontSize: "14px", color: iconColor }}
        ></i>
      </div>
      <div>
        <div
          style={{
            fontSize: "13px",
            fontWeight: 700,
            color: "#1e293b",
            lineHeight: 1.2,
          }}
        >
          {title}
          {required && (
            <span style={{ color: "#dc2626", marginLeft: "3px" }}>*</span>
          )}
        </div>
        {hint && (
          <div style={{ fontSize: "11px", color: "#6b7280", marginTop: "2px" }}>
            {hint}
          </div>
        )}
      </div>
    </div>
    <div>{children}</div>
  </div>
);

//  RadioGroup
const RadioGroup = ({ name, value, onChange, disabled }) => (
  <div style={{ display: "flex", gap: "8px" }}>
    {["Yes", "No"].map((v) => {
      const isActive = value === v;
      const activeColor = v === "Yes" ? "#059669" : "#6b7280";
      const activeBg = v === "Yes" ? "#ecfdf5" : "#f3f4f6";
      const activeBorder = v === "Yes" ? "#6ee7b7" : "#d1d5db";
      return (
        <label
          key={v}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "6px",
            padding: "6px 14px",
            borderRadius: "20px",
            cursor: disabled ? "not-allowed" : "pointer",
            border: isActive
              ? `2px solid ${activeBorder}`
              : "2px solid #e5e7eb",
            background: isActive ? activeBg : "#fafafa",
            color: isActive ? activeColor : "#9ca3af",
            fontWeight: isActive ? 700 : 500,
            fontSize: "13px",
            transition: "all 0.2s",
            opacity: disabled ? 0.7 : 1,
            userSelect: "none",
          }}
        >
          <input
            type="radio"
            name={name}
            disabled={disabled}
            checked={isActive}
            onChange={() => !disabled && onChange(v)}
            style={{ display: "none" }}
          />
          {isActive ? (
            <i
              className={`bi ${v === "Yes" ? "bi-check-circle-fill" : "bi-x-circle-fill"}`}
              style={{ fontSize: "12px" }}
            ></i>
          ) : (
            <i className="bi bi-circle" style={{ fontSize: "12px" }}></i>
          )}
          {v}
        </label>
      );
    })}
  </div>
);

//  Button style helper
const btnStyle = (bg, color, border = "none") => ({
  display: "inline-flex",
  alignItems: "center",
  gap: "6px",
  padding: "8px 16px",
  border,
  borderRadius: "8px",
  background: bg,
  color,
  fontWeight: 700,
  fontSize: "13px",
  cursor: "pointer",
  transition: "all 0.2s",
  boxShadow: border === "none" ? "0 2px 8px rgba(0,0,0,0.15)" : "none",
});

export default BuyerReverseAuctionDetails;
